import React from 'react';
import { bool, func } from 'prop-types';

import { PopUpCenterV2 } from 'Component/PopUp';
import { Button } from '@ajaibid/components';
import { noop } from '@ajaibid/utils';
import { stySuccessWrapper, styTextContent, styTextTitle } from './style';

const SuccessUpload = ({ showSuccessPopup, onHideSuccessPopup }) => {
  return (
    <PopUpCenterV2 show={showSuccessPopup}>
      <div className={stySuccessWrapper}>
        <p className={styTextTitle}>Bukti Transfer Telah Diunggah</p>
        <p className={styTextContent}>
          Kami akan segera verifikasi setoranmu dalam waktu 1 hari kerja (tidak termasuk Sabtu,
          Minggu dan libur nasional)
        </p>
      </div>
      <div>
        <Button
          variant="primary"
          onClick={() => {
            onHideSuccessPopup();
            window.location.reload();
          }}
          fluid
        >
          Lihat Status
        </Button>
      </div>
    </PopUpCenterV2>
  );
};

SuccessUpload.propTypes = {
  showSuccessPopup: bool,
  onHideSuccessPopup: func,
};

SuccessUpload.defaultProps = {
  showSuccessPopup: false,
  onHideSuccessPopup: noop,
};

export default SuccessUpload;
